<template>
  <InteractionStep
                   :disabled-next="!canNext"
                   :pending-next="pendingSave"
                   @next="onSave">

    <template v-slot:content>
      <div class="step-ticket">
        <div class="step-ticket__head">
          <h4 class="step-ticket__head-title">{{ $tInteraction('The employer will be waiting for you at') }}</h4>
          <div class="step-ticket__head-panel">
            <div class="step-ticket__head-panel-item">{{ address }}</div>
            <div class="step-ticket__head-panel-item">{{ dateString }}
              <template v-if="timeString">{{ $tInteraction('to') }}</template>
              {{ timeString }}
            </div>
          </div>
        </div>
        <div class="step-ticket__section">
          <div class="step-ticket__group">
            <h3 class="step-ticket__title">{{ $tInteraction('You can buy a ticket right here') }}</h3>
            <InteractionWidget>
              <script type="text/x-epodroznik-module"
                      data-module-name="ConnectionsSearcher"
                      id="ConnectionsSearcher"></script>
<!--              <script type="text/x-epodroznik-module"-->
<!--                      data-module-name="UserMenu"-->
<!--                      id="UserMenu"></script>-->
            </InteractionWidget>
          </div>

          <div class="step-ticket__group">
            <h3 class="step-ticket__title">{{ $tInteraction('Upload your purchased ticket here') }}</h3>
            <div class="step-ticket__dropzone-wrap">
              <div class="step-contract__dropzone">

                <div @click="$refs.fileInput.click()"
                     ref="dropzone"
                     :class="{'_drag-over': dragoverMixin}"
                     class="step-contract__dropzone-btn">
                  <input ref="fileInput"
                         class="d-none"
                         type="file"
                         multiple
                         @change="onFilesInputMixin"
                  >
                  <BaseSvg name="ico-plus"
                           height="2.7rem"/>
                  <span>{{$tInteraction('Upload')}}</span>
                </div>

                <span class="step-contract__dropzone-or">{{$tInteraction('or')}}</span>

                <div @click.prevent="onShowPopup"
                     class="step-contract__dropzone-btn">
                  <BaseSvg name="ico-photo"
                           width="3rem"
                           height="2.7rem"/>
                  <span>{{$tInteraction('To photograph')}}</span>
                </div>
                <BasePreloader v-if="pendingUpload"/>
              </div>
              <BaseAlert :value="errorUpload" class="step-ticket__error  _error"/>
            </div>
            <div v-if="filesUploaded.length"
                 class="step-ticket__download-files">
              <div class="step-ticket__download-label">{{ $tInteraction('Already loaded') }}:</div>
              <div class="step-ticket__download-files-list">
                <div v-for="(file, index) in filesUploaded"
                     :key="file.id"
                     :class="file.reject_reasons || file.reject_reasons_description ? '_warning' : null"
                     class="step-contract__download-file">
                  <div class="step-contract__download-file-wrap">
                    <FileShow :value="file"
                              class="step-contract__download-file-el"/>
                  </div>
                  <button type="button"
                          @click.prevent="onDeleteFile(index)"
                          class="step-contract__download-delete">
                    <BaseSvg name="ico-trash"/>
                  </button>
                  <!--                  <BaseInputError :value="createErrors(file)"-->
                  <!--                                  class="step-contract__download-file-warning  _warning"/>-->
                  <ul v-if="createErrors(file).length"
                      class="step-contract__download-file-warning  _warning  input-error">
                    <li v-for="(error, index) in createErrors(file)"
                        :key="index"
                        class="input-error__item">
                      <template v-if="index === 0">*</template>
                      {{ error }}
                    </li>
                  </ul>
                  <BasePreloader v-if="file.pending"/>
                </div>
              </div>
            </div>

            <transition name="fade">
              <div v-if="showPopup"
                   class="step-ticket__popup photo-popup">
                <button type="button"
                        class="photo-popup__close"
                        @click.prevent="onClosePopup">
                  <BaseSvg name="ico-close"/>
                </button>

                <div class="photo-popup__content">
                  <img src="../../../assets/img/svg/phone-popup.svg"
                       alt="phone"
                       class="photo-popup__img">
                  <h3 class="photo-popup__title">
                    {{ $tInteraction('To take a photo, open the site on your mobile device') }}</h3>
                  <div class="photo-popup__text text">
                    <p>{{$tInteraction('take_photo_mobile_text')}}</p>
                  </div>

                  <button type="button"
                          @click.prevent="onClosePopup"
                          class="photo-popup__btn base-btn base-btn--outline-dark">
                    <span class="base-btn__text">{{ $tInteraction('Continue booting from PC') }}</span>
                  </button>
                </div>
              </div>
            </transition>
          </div>
        </div>

        <div v-if="arrival_info.transfer === 1"
             class="button-checkboxes">
          <div class="button-checkboxes__list">
            <div class="button-checkboxes__item-col">
              <label class="checkbox">
                <input
                    v-model="ticketNotNeed"
                    type="checkbox"
                    name="type-option"
                    hidden
                >
                <span class="checkbox__mark">
                  <BaseSvg name="ico-check"/>
                </span>
                <span class="checkbox__text">
                  {{ $tInteraction("I don't need a ticket. I'll get there myself") }}
                </span>
              </label>
            </div>
          </div>
        </div>

        <!--<div v-if="arrival_info.transfer === 1"
             class="step-text__options step-options">
          <div class="step-options__inner">
            <label class="step-options__item">
              <input
                  v-model="ticketNotNeed"
                  type="checkbox"
                  name="type-option"
                  hidden
              >
              <span class="step-options__item-mark">
                <BaseSvg name="ico-check"/>
              </span>
              <button
                  type="button"
                  class="base-btn step-ticket__cancel"
                  style="pointer-events: none; font-weight: normal; border: none"
              >
                <BaseSvg name="ico-close"
                         width="1rem"
                         height="1rem"/>
                <span>{{ $tInteraction("I don't need a ticket. I'll get there myself") }}</span>
              </button>
            </label>
          </div>
        </div>-->


      </div>
      <BaseAlert :value="error || errorMixin" class="step-ticket__error  _error"/>
    </template>

  </InteractionStep>
</template>

<script>
import InteractionStep from '../InteractionStep'
import InteractionWidget from '../InteractionWidget'
import FileShow from '../../FileShow'
import fileUploadMixin from '../../../mixins/fileUploadMixin'
import {http} from "@/axios"
// import BaseInputError from '../../BaseInputError'
import parseDateForLocal from "../../../helpers/parseDateForLocal"
import interactionStepMixin from "@/mixins/interactionStepMixin"

// import windowSizeMixin from '../../../mixins/windowSizeMixin'
// import {blockScroll, unBlockScroll} from '../../../helpers/scroll'

export default {
  name: 'InteractionStepContract',
  components: {
    // BaseInputError,
    InteractionWidget,
    InteractionStep,
    FileShow,
  },
  mixins: [
    fileUploadMixin,
    interactionStepMixin,
    // windowSizeMixin
  ],
  data() {
    return {
      ticketNotNeed: false,
      showPopup: false,
      timer: null,
      pendingIframe: true,
      pendingSave: false,
      pendingUpload: false,
      uploadFileMethodNameMixin: ['onUploadFiles'],
      filesUploaded: [],
      error: null,
      errorUpload: null,
      arrival_info: null,
    }
  },
  computed: {
    currentLang() {
      const lang = this.$store.state.locales[this.$store.state.currentLocale]

      return lang.regional.substring(0, 2)
    },
    step() {
      return this.$store.state.interaction.step
    },
    date() {
      if (!this.arrival_info) return
      return parseDateForLocal(this.arrival_info.data)
      // d.setHours(this.arrival_info.time_hours)
      // d.setMinutes(this.arrival_info.time_minutes)
      // return d
    },
    dateString() {
      const date = this.date
      if (!date) return
      return this.date.toLocaleDateString()
    },
    timeString() {
      const date = this.date
      if (!date) return
      return date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
    },
    address() {
      const a = [this.arrival_info.city, this.arrival_info.street_name, this.arrival_info.street_number]
      return a.filter(a => a).join(', ')
    },
    canNext() {
      return this.ticketNotNeed
          || this.filesUploaded.some(item => {
            return !item.reject_reasons && !item.reject_reasons_description
          })
    }
  },
  methods: {
    onSave(ticketNotNeed = this.ticketNotNeed) {
      this.error = null
      this.pendingSave = true

      http.post(`/api/new-interaction/${this.$route.params.id}/${this.step}`, {
        ticket_not_need: ticketNotNeed
      }).then(async () => {
        await this.$store.dispatch('interaction/loadInteraction')
      }).catch(e => {
        this.handleInteractionError(e)
      }).finally(() => {
        this.pendingSave = false
      })
    },
    onUploadFiles(files) {
      this.errorUpload = null
      this.pendingUpload = true
      const formData = new FormData()
      files.forEach(file => {
        formData.append('files[]', file)
      })

      http.post(`/api/new-interaction/${this.$route.params.id}/upload/${this.step}`, formData).then(({data}) => {
        this.filesUploaded = this.filesUploaded.concat(data.data)
      }).catch(e => {
        this.errorUpload =  this.handleInteractionError(e, false)
      }).finally(() => {
        this.pendingUpload = false
      })
    },
    onDeleteFile(index) {
      const file = this.filesUploaded[index]
      this.$set(file, 'pending', true)

      http.delete(`/api/new-interaction/${this.$route.params.id}/${file.id}`).then(() => {
        this.$delete(this.filesUploaded, index)
      }).catch(e => {
        this.errorUpload =  this.handleInteractionError(e, false)
        this.$set(file, 'pending', false)
      })
    },
    onShowPopup() {
      // if(this.windowSizeMixin.width < 768) {
      //   blockScroll()
      // }
      this.showPopup = true
    },
    onClosePopup() {
      // unBlockScroll()
      this.showPopup = false
    },
    // checkMob() {
    //   clearTimeout(this.timer)
    //   this.timer = setTimeout(() => {
    //     if(this.showPopup && this.windowSizeMixin.width > 767) {
    //       this.onClosePopup()
    //     }
    //   }, 200)
    // }
    createErrors(file) {
      const a = []
      if (file.reject_reasons) a.push(file.reject_reasons.name)
      if (file.reject_reasons_description) a.push(file.reject_reasons_description)

      return a
    }
  },
  // mounted() {
  //   window.addEventListener('resize', this.checkMob)
  // },
  // beforeDestroy() {
  //   this.onClosePopup()
  //   window.removeEventListener('resize', this.checkMob)
  // }

  created() {
    const arr = Array.isArray(this.$store.state.interaction.stepData.data) ? this.$store.state.interaction.stepData.data : []
    this.filesUploaded = arr.map(item => {
      const r = item.file
      r.reject_reasons = item.reject_reasons
      r.reject_reasons_description = item.reject_reasons_description
      return r
    })

    this.arrival_info = this.$store.state.interaction.stepData.arrival_date
  }
}
</script>

<style>

</style>
